/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import { IZZZCharacter } from '../../../common/model/graphql-types';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IProps {
  employee: IZZZCharacter;
  showLabel?: boolean;
  showIcon?: boolean;
  showEidolon?: boolean;
}

export const ZZZCharacterIconNoLink: React.FC<IProps> = ({
  employee,
  showLabel,
  showEidolon
}) => {
  const image = employee.smallImage
    ? getImage(employee.smallImage.localFile.childImageSharp)
    : null;
  return (
    <>
      <div
        className={`avatar zzz rarity-${employee.rarity} ${
          showLabel ? showLabel : ''
        }`}
      >
        {image && (
          <GatsbyImage
            className="disable-transition"
            image={image}
            alt={`${employee.name}`}
          />
        )}
        {showEidolon && (
          <span className="floating-element zzz">
            <div className="element">
              {employee.element === 'Physical' && (
                <StaticImage
                  src="../../../../images/zzz/icons/ele_physical.png"
                  alt={employee.element}
                />
              )}
              {employee.element === 'Fire' && (
                <StaticImage
                  src="../../../../images/zzz/icons/ele_fire.png"
                  alt={employee.element}
                />
              )}
              {employee.element === 'Ice' && (
                <StaticImage
                  src="../../../../images/zzz/icons/ele_ice.png"
                  alt={employee.element}
                />
              )}
              {employee.element === 'Ether' && (
                <StaticImage
                  src="../../../../images/zzz/icons/ele_ether.png"
                  alt={employee.element}
                />
              )}
              {employee.element === 'Electric' && (
                <StaticImage
                  src="../../../../images/zzz/icons/ele_electric.png"
                  alt={employee.element}
                />
              )}
            </div>
          </span>
        )}

        {showEidolon && (
          <span
            className={`floating-element cinema ${
              employee.rarity === 'A' ? 'rarity-A' : 'rarity-S'
            } `}
          >
            {employee.rarity === 'A' ? <>M0</> : <>M0</>}
          </span>
        )}
      </div>
      {showLabel && <span className="emp-name">{employee.name}</span>}
    </>
  );
};
